<div class="card">
    <div class="card-header">
        <h3 class="mb-0">Remove Player</h3>
    </div>
    <div class="card-body">
        <table class="table table-sm">
            <thead>
                <tr>
                    <td>Checked to Remove</td>
                    <td>Username</td>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let player_id of player_ids">
                    <td><input [id]="'aa_' + player_id.id" type="checkbox" [value]="1" [(ngModel)]="player_id.remove"/></td>
                    <th><label [for]="'aa_' + player_id.id">{{player_id.username}}</label></th>
                </tr>
            </tbody>
        </table>
        <button (click)="remove()" class="btn btn-primary">Remove Player</button>
    </div>
</div>